import Edit from './Edit/Edit';
import View from './View/View';

export const EditProfile = Edit;
export const ViewProfile = View;
